import { VpnKeyOutlined, LockOpen, Login } from '@mui/icons-material';

type IconComponentProps = {
  color: string;
  step: number;
};

export const getIconComponent = ({ color, step }: IconComponentProps) => {
  switch (step) {
    case 1:
      return <LockOpen fontSize="small" sx={{ color }} />;
    case 2:
      return <VpnKeyOutlined fontSize="small" sx={{ color }} />;
    case 3:
      return <Login fontSize="small" sx={{ color }} />;
    default:
      return <LockOpen fontSize="small" color="disabled" />;
  }
};
